<template>
	<div class="btn-group" data-toggle="buttons">
		<button
			class="btn btn-sm"
			@click="$emit('input', 'todos')"
			:class="{ 'btn-success': value == 'todos' }"
		>
			Novas
		</button>
		<button
			class="btn btn-sm"
			@click="$emit('input', 'positivos')"
			:class="{ 'btn-primary': value == 'positivos' }"
		>
			Positivos
		</button>
		<button
			class="btn btn-sm"
			@click="$emit('input', 'inconclusivos')"
			:class="{ 'btn-warning': value == 'inconclusivos' }"
		>
			Inconclusivos
		</button>
		<button
			class="btn btn-sm"
			@click="$emit('input', 'negativos')"
			:class="{ 'btn-danger': value == 'negativos' }"
		>
			Negativo
		</button>
	</div>
</template>
<script>
	export default {
		props: ['value'],
	};
</script>



// WEBPACK FOOTER //
// src/components/exames_dashboard/components/btn-status.vue